import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const isSalesManagerSlice = createSlice<boolean, {}, 'isSalesManager'>({
  initialState,
  name: 'isSalesManager',
  reducers: {},
});
export const { reducer: isSalesManagerReducer } = isSalesManagerSlice;
